import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * CompleteAssignmentDialog - Dialog for completing assignments
 * @param {boolean} open - Whether the dialog is open
 * @param {Array} openAssignments - List of open assignments
 * @param {Object} selectedAssignment - Currently selected assignment
 * @param {Function} onSelectAssignment - Callback when an assignment is selected
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onComplete - Callback when complete is confirmed
 * @param {boolean} loading - Whether completion is in progress
 */
export default function CompleteAssignmentDialog({
  open,
  openAssignments,
  selectedAssignment,
  onSelectAssignment,
  onClose,
  onComplete,
  loading = false
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Complete Assignment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Select an assignment to mark as complete:
        </Typography>
        <List>
          {openAssignments.map((assignment) => (
            <ListItemButton
              key={assignment.eventId}
              selected={selectedAssignment?.eventId === assignment.eventId}
              onClick={() => onSelectAssignment(assignment)}
            >
              <ListItemText
                primary={assignment.description}
                secondary={new Date(assignment.createdAt).toLocaleDateString()}
              />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onComplete} disabled={loading || !selectedAssignment} variant="contained">
          {loading ? <CircularProgress size={24} /> : 'Complete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
